export default "__VITE_ASSET__D9VV$TY1__"